var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#555555"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6816_10263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.5498C8.5 12.8594 9.05964 12.2998 9.75 12.2998H13.75C14.4404 12.2998 15 12.8594 15 13.5498V13.5498C15 14.2402 14.4404 14.7998 13.75 14.7998H9.75C9.05964 14.7998 8.5 14.2402 8.5 13.5498V13.5498Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.0498C8.5 10.3594 9.05964 9.7998 9.75 9.7998H13.75C14.4404 9.7998 15 10.3594 15 11.0498V11.0498C15 11.7402 14.4404 12.2998 13.75 12.2998H9.75C9.05964 12.2998 8.5 11.7402 8.5 11.0498V11.0498Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5498C8.5 7.85945 9.05964 7.2998 9.75 7.2998H13.75C14.4404 7.2998 15 7.85945 15 8.5498V8.5498C15 9.24016 14.4404 9.7998 13.75 9.7998H9.75C9.05964 9.7998 8.5 9.24016 8.5 8.5498V8.5498Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.0498C8.5 5.35945 9.05964 4.7998 9.75 4.7998H13.75C14.4404 4.7998 15 5.35945 15 6.0498V6.0498C15 6.74016 14.4404 7.2998 13.75 7.2998H9.75C9.05964 7.2998 8.5 6.74016 8.5 6.0498V6.0498Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 11.5996,
    r: 4.5,
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.49994,
    cy: 11.5997,
    r: 3.06256,
    fill: "#555555",
    stroke: "white",
    strokeWidth: 0.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4999 9.59961L7.52561 9.73854C7.67848 10.5648 8.23058 11.2617 8.99993 11.5996V11.5996V11.5996C8.23058 11.9375 7.67848 12.6345 7.52561 13.4607L7.4999 13.5997L7.4742 13.4607C7.32133 12.6345 6.76923 11.9375 5.99988 11.5996V11.5996V11.5996C6.76923 11.2617 7.32133 10.5648 7.4742 9.73854L7.4999 9.59961Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6816_10263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyToken);
export default __webpack_public_path__ + "static/media/empty-token.a4aaed3fde56546d70af8d56b833eb5a.svg";
export { ForwardRef as ReactComponent };